import { IPropertyDetailsResponse } from "@/src-refactor/modules/store/qrtk/services/realestate/responses/property-details.response";

export const prepareDetailPropertyCardLocation = (
  property: IPropertyDetailsResponse
) => {
  return `${property?.sector}, ${property?.city}`;
};
